<form #createConvenioForm="ngForm">
    <app-custom-modal #modal [title]="'Realizar vínculo com convênio'" [subtitle]="''" (onCloseClick)="modal.close()"
        (onSaveClick)="save()" [saveLabel]="'Salvar  →'" hideCancel [saveDisabled]="createConvenioForm.invalid">
        <div class="container mt-4">
            <div class="mb-4">
                <label for="convenio-selected" class="form-label required">Convênio</label>
                <select disabled name="convenio-selected"  id="convenio-selected" class="custom-select form-control" [(ngModel)]="pacienteConvenio.convenioId">
                    <option *ngFor="let convenio of convenios" [value]="convenio.id">{{convenio.nomeFantasia ?? convenio.razaoSocial}}</option>
                </select>
            </div>
            <div class="mb-4">
                <label for="plano" class="form-label required">Plano</label>
                <input type="text" class="form-control" name="plano" maxlength="64" [(ngModel)]="pacienteConvenio.plano"
                    #planoModel="ngModel" #planoEl id="plano" required placeholder="Digite aqui" />
                <abp-validation-summary [control]="planoModel" [controlEl]="planoEl"></abp-validation-summary>
            </div>
            <div class="mb-4">
                <label for="numeroCarteira" class="form-label required">Número da carteira</label>
                <input type="text" onlyNumbers class="form-control" name="numeroCarteira" maxlength="150"
                    [(ngModel)]="pacienteConvenio.numeroCarteira" placeholder="Digite aqui" #numeroCarteiralModel="ngModel"
                    #numeroCarteiralEl id="numeroCarteiral" required />

                <abp-validation-summary [control]="numeroCarteiralModel"
                    [controlEl]="numeroCarteiralEl"></abp-validation-summary>
            </div>
            <div class="mb-4">
                <label for="dataValidade" class="form-label required">Data de validade</label>
                <input type="text" class="form-control" name="dataValidade" [(ngModel)]="data" mask="00/00/0000" required
                    placeholder="dd/mm/aaaa" #dataValidadeModel="ngModel" #dataValidadeEl id="dataValidade" autocomplete="off"/>
                <abp-validation-summary [control]="dataValidadeModel"
                    [controlEl]="dataValidadeEl"></abp-validation-summary>
            </div>
        </div>
    </app-custom-modal>
</form>